/* v1.30 TLB grouped search (Brad, Oct 30): Market, Journal, Shop the Look.
   Index = live Liquid JSON (templates/page.search-index.liquid, page.search-looks.liquid), lazy-loaded on first
   focus of a search box. Links go to on-site pages only. Never shows counts. Looks never use video frames. */
(function () {
  if (window.TLBSearch) return;
  var core = null, looks = null, pending = {};
  function u(view, pg) {
    var q = '/pages/shop?view=' + view + (pg > 1 ? '&page=' + pg : '');
    try { var t = window.Shopify && Shopify.theme; if (t && t.role && t.role !== 'main') q += '&preview_theme_id=' + t.id; } catch (e) {}
    return q;
  }
  function get(url) { return fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); }
  function loadCore() {
    if (pending.c) return pending.c;
    return pending.c = get(u('search-index', 1)).then(function (d) {
      var m = d.m || [], j = d.j || [], more = [];
      for (var p = 2; p <= (d.pp || 1) && p <= 8; p++) more.push(get(u('search-index', p)).then(function (x) { m = m.concat(x.m || []); }).catch(function () {}));
      return Promise.all(more).then(function () { core = { m: m.filter(function (x) { return x.k !== 'x' && x.u; }), j: j }; prep(core.m); prep(core.j); return core; });
    }).catch(function (e) { pending.c = null; throw e; });
  }
  function loadLooks() {
    if (pending.l) return pending.l;
    return pending.l = get(u('search-looks', 1)).then(function (d) {
      looks = (d.l || []).sort(function (a, b) { return b.r - a.r; });
      looks.forEach(function (x) { x.u = '/pages/shop-the-look?view=look&page=' + x.r; x.k = 'l'; if (x.i && x.i.charAt(0) === '~') x.i = 'https://product-images-cdn.liketoknow.it/' + x.i.slice(1) + '?v=2&w=240'; });
      prep(looks); return looks;
    }).catch(function (e) { pending.l = null; throw e; });
  }
  function load() { return Promise.all([loadCore().catch(function () {}), loadLooks().catch(function () {})]); }
  function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/&amp;/g, '&').replace(/[^a-z0-9&]+/g, ' '); }
  function stem(w) { return w.length > 3 ? w.replace(/(ies)$/, 'y').replace(/(es|s)$/, '') : w; }
  function prep(list) { list.forEach(function (x) { x._t = ' ' + norm(x.t) + ' '; x._s = ' ' + norm(x.t + ' ' + (x.b || '') + ' ' + (x.c || '') + ' ' + (x.g || '') + ' ' + (x.s || '')) + ' '; }); }
  function score(x, words) {
    var sc = 0;
    for (var i = 0; i < words.length; i++) {
      var w = words[i];
      if (x._s.indexOf(' ' + w) < 0) return 0;
      sc += x._t.indexOf(' ' + w) >= 0 ? 3 : 1;
    }
    if (x.k === 'b' || x.k === 'd') sc += 2;
    return sc;
  }
  function find(list, q, max) {
    var words = norm(q).split(' ').filter(Boolean).map(stem);
    if (!words.length || !list) return [];
    var out = [];
    list.forEach(function (x, i) { var s = score(x, words); if (s) out.push([s, i, x]); });
    out.sort(function (a, b) { return b[0] - a[0] || a[1] - b[1]; });
    return out.slice(0, max).map(function (a) { return a[2]; });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var LABEL = { p: function (x) { return x.b || 'Pick'; }, b: function () { return 'Brand'; }, d: function () { return 'Market'; }, j: function (x) { return 'Journal' + (x.d ? ' · ' + x.d : ''); }, l: function (x) { return 'Look' + (x.d ? ' · ' + x.d : ''); } };
  function item(x) {
    var img = x.i ? '<img src="' + esc(x.i) + '" alt="" loading="lazy" decoding="async" referrerpolicy="no-referrer" width="120" height="120">' : '';
    return '<li class="tlb-sr__item"><a class="tlb-sr__link" href="' + esc(x.u) + '"><span class="tlb-sr__media' + (img ? '' : ' tlb-sr__media--none') + '">' + img + '</span><span class="tlb-sr__txt"><span class="tlb-sr__type">' + esc(LABEL[x.k](x)) + '</span><span class="tlb-sr__title">' + esc(x.t) + '</span></span></a></li>';
  }
  var SECTIONS = [['m', 'Market', '/pages/shop', 'Browse the Market'], ['j', 'Journal', '/blogs/journal', 'All Journal posts'], ['l', 'Shop the Look', '/pages/shop-the-look', 'All looks']];
  function render(el, q, max, full) {
    q = (q || '').trim();
    if (!q) { el.innerHTML = '<p class="tlb-sr__hint">Search the Market, the Journal and Shop the Look. Try “rug”, “bedding” or “Quince”.</p>'; return; }
    var lists = { m: core && core.m, j: core && core.j, l: looks }, html = '', any = false, loading = !core || !looks;
    SECTIONS.forEach(function (s) {
      var all = find(lists[s[0]], q, full ? 400 : max);
      if (!all.length) return;
      any = true;
      var first = all.slice(0, max), rest = all.slice(max);
      html += '<section class="tlb-sr__sec tlb-sr__sec--' + s[0] + '" aria-label="' + s[1] + '"><div class="tlb-sr__head"><h2 class="tlb-sr__h">' + s[1] + '</h2><a class="tlb-sr__all" href="' + s[2] + '">' + s[3] + '</a></div><ul class="tlb-sr__list" role="list">' + first.map(item).join('') + '</ul>' +
        (rest.length && full ? '<template>' + rest.map(item).join('') + '</template><button type="button" class="tlb-obtn tlb-sr__more" data-more>Show more</button>' : '') + '</section>';
    });
    if (!any) html = loading ? '<p class="tlb-sr__hint">Searching…</p>' : '<div class="tlb-sr__empty"><p class="tlb-sr__h">Nothing matched “' + esc(q) + '”.</p><p class="tlb-sr__hint">Try a simpler word like “rug”, “pillow” or “mantel”, or browse the <a href="/pages/shop">Market</a>, the <a href="/blogs/journal">Journal</a> or <a href="/pages/shop-the-look">Shop the Look</a>.</p></div>';
    el.innerHTML = html;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.tlb-sr__more'); if (!b) return;
    var t = b.previousElementSibling, ul = b.parentNode.querySelector('.tlb-sr__list');
    var tmp = document.createElement('ul'); tmp.innerHTML = t.innerHTML;
    var kids = Array.prototype.slice.call(tmp.children), take = kids.slice(0, 12);
    take.forEach(function (li) { ul.appendChild(li); });
    var left = kids.slice(12); if (left.length) t.innerHTML = left.map(function (li) { return li.outerHTML; }).join(''); else { t.remove(); b.remove(); }
  });

  /* Header search modal */
  function initModal() {
    var box = document.querySelector('[data-tlb-sr-modal]'); if (!box) return;
    var comp = box.closest('predictive-search-component'); var input = comp && comp.querySelector('input[name="q"]');
    if (!input) return;
    comp.classList.add('tlb-sr-on');
    var t;
    function go() { box.hidden = false; render(box, input.value, 4, false); var rb = comp.querySelector('.predictive-search__reset-button'); if (rb) rb.hidden = !input.value; }
    input.addEventListener('focus', function () { load().then(go); go(); });
    input.addEventListener('input', function () { clearTimeout(t); t = setTimeout(function () { load().then(go); go(); }, 120); });
    var rb = comp.querySelector('.predictive-search__reset-button');
    if (rb) rb.addEventListener('click', function () { input.value = ''; go(); input.focus(); });
    var trig = document.querySelectorAll('[aria-controls="search-modal"], .search-action, [on\\:click*="search-modal"]');
    trig.forEach(function (b) { b.addEventListener('pointerenter', function () { load(); }, { once: true }); });
  }
  /* /search page */
  function initPage() {
    var el = document.querySelector('[data-tlb-sr-page]'); if (!el) return;
    var q = new URLSearchParams(location.search).get('q') || el.getAttribute('data-q') || '';
    document.documentElement.classList.add('tlb-sr-page-on');
    render(el, q, 8, true);
    load().then(function () { render(el, q, 8, true); });
  }
  window.TLBSearch = { load: load, find: find };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initModal(); initPage(); }); else { initModal(); initPage(); }
})();
